<!-- Display Virtual Geomatics Lidar tool -->
<div *ngIf="eeService.showLidar"style="width: 100%; height: 100%; position: absolute; top: 70px; z-index: 9999; background: white" >
  <app-configurable-header
    aria-label="Close"
    headingText="Lidar Data"
    [variant]="'none'"
    (actionOne)="eeService.toggleLidarIframe(null, null, null, null, null)"
    [iconOne]="'cross'"
    [tooltipOne]="'Close'"
    data-dismiss="modal"
  ></app-configurable-header>
  <!-- Change iframe height to make sure we are not cutting off bottom of ifram urls -->
  <iframe style="width: 100%; height: 75%" [src]="eeService.lidarUrl" frameborder="0"></iframe>
</div>



<!-- w-50 -->

<div class="container-fluid h-100">

  <!-- App Header, with Nav toolbar -->
  <header class="row h-5" aria-label="header" id="header">
    <div class="col-12">
      <sms-header
        (headerOptionEvent)="invokePopup($event)"
        [Graphic]="Graphic"
        [Query]="Query"
        [FeatureLayer]="FeatureLayer"
        [FeatureTable]="FeatureTable"
        [TimeExtent]="TimeExtent"
        [SimpleLineSymbol]="SimpleLineSymbol"
        [SimpleRenderer]="SimpleRenderer"
        [Color]="Color"
        [TimeSlider]="TimeSlider"
        [TimeInfo]="TimeInfo"
        [QueryTask]="QueryTask"
        [map]="map"
        [registry]="registry"
        [Geoprocessor]="Geoprocessor"
        [Popup]="Popup"
        [domConstruct]="domConstruct"
        (showCard)="showAssetViewer($event)"
      >
      </sms-header>
    </div>
  </header>

  <div class="row h-95">
    <div class="col-12" style="padding: 0px">
      <h1 class="sr-only">RSAM Main Page Map and Tools</h1>

      <!-- Here's the DIV that we inject the map into -->
      <main #mapViewNode class="map-node" role="main" aria-label="mapView">

        <!-- Search -->
        <div class="searchDiv ml-3 p-3" [style.display]="showSearch ? 'block' : 'none'" data-html2canvas-ignore="true">
          <sms-search-tool
            [map]="map"
            [searchWidget]="searchWidget"
            [InfoTemplate]="InfoTemplate"
            [Circle]="Circle"
            [Units]="Units"
            [SimpleFillSymbol]="SimpleFillSymbol"
            [SimpleLineSymbol]="SimpleLineSymbol"
            [Color]="Color"
            [Graphic]="Graphic"
            [Query]="Query"
            [Point]="Point"
            [PictureMarkerSymbol]="PictureMarkerSymbol"
            [Locator]="Locator"
            [FeatureLayer]="FeatureLayer"
            [SimpleMarkerSymbol]="SimpleMarkerSymbol"
            [PopupTemplate]="PopupTemplate"
            [Popup]="Popup"
            [domConstruct]="domConstruct"
            [webMercatorUtils]="webMercatorUtils"
            [layerData]="layerData"
            [ScreenPoint]="ScreenPoint"
            [GraphicsLayer]="GraphicsLayer"
            [PopupExtended]="PopupExtended"
            [RelationshipQuery]="RelationshipQuery"
            [all]="all"
            [currentUser]="currentUser"
            [drawTool]="drawTool"
            [QueryTask]="QueryTask"
            (showmaintenanceViewer)="showTaskData($event)"
            (category)="tasksSelected($event)"
            (showCard)="showAssetViewer($event)"
            (showGrid)="showAssetTable($event)"
            (data)="processEmittedData($event)"
            (index)="setRowIndex($event)"
            (layerIndex)="setSelLayerIndex($event)"
          ></sms-search-tool>
        </div>

        <!-- Select Tools Container   -->
        <div class="selectDiv" *ngIf="showSelect" data-html2canvas-ignore="true">
          <sms-select-tool
            [Point]="Point"
            [map]="map"
            [SimpleFillSymbol]="SimpleFillSymbol"
            [SimpleLineSymbol]="SimpleLineSymbol"
            [Query]="Query"
            [SimpleMarkerSymbol]="SimpleMarkerSymbol"
            [drawTool]="drawTool"
            [Color]="Color"
            [Graphic]="Graphic"
            [all]="all"
            [QueryTask]="QueryTask"
            [webMercatorUtils]="webMercatorUtils"
            [PictureMarkerSymbol]="PictureMarkerSymbol"
            [GraphicsLayer]="GraphicsLayer"
            [FeatureLayer]="FeatureLayer"
            (taskTableVisibilityChanged)="showTaskTable($event)"
            (assetViewerVisibilityChanged)="showAssetViewer($event)"
            (assetTableVisibilityChanged)="showAssetTable($event)"
            (data)="processEmittedData($event)"
            (category)="tasksSelected($event)"
            (index)="setRowIndex($event)"
            (layerIndex)="setSelLayerIndex($event)">
          </sms-select-tool>
        </div>

        <!-- Measure -->
        <div class="measurebound">
          <div
            id="measure"
            class="measureDiv card"
            [style.display]="showMeasure ? 'block' : 'none'"
            [style.transform]="!showMeasure ? 'none' : ''"
            data-html2canvas-ignore="true"
            style="position: absolute"
            cdkDrag
            cdkDragBoundary=".measurebound">
            <app-configurable-header
              aria-label="Close"
              [headingText]="'Esri-map.measurementdiv.measurement' | translate"
              [variant]="'none'"
              [iconOne]="'cross'"
              cdkDragHandle
              (actionOne)="close($event, 'measure')"
              [tooltipOne]="'Close'"
              data-dismiss="modal">
            </app-configurable-header>

            <div class="card-body">
              <div id="measureWidgetDiv"></div>
            </div>
          </div>
        </div>

        <!-- Basemap gallery -->
        <div class="basemapDiv" [style.display]="showBaseMapGallery ? 'block' : 'none'">
          <!-- TSDRSAM-1806 -->
          <app-configurable-header [headingText]="'Map Types'" [variant]="'none'" [iconOne]="'cross'" [tooltipOne]="'Close'" (actionOne)="toggleBasemapGallery()"> </app-configurable-header>
          <div class="basemap-list">
            <div id="basemapGalleryDiv"></div>
          </div>
        </div>

        <!-- Layers -->
        <div class="layersDiv p-3" [style.display]="showLayers ? 'block' : 'none'" data-toggle="collapse">
          <app-configurable-header
            [headingText]="'Esri-map.layerdiv.layer' | translate"
            [variant]="'none'"
            [iconOne]="showLayerList ? 'arrow-up' : 'arrow-down'"
            [tooltipOne]="showLayerList ? 'Minimize' : 'Expand'"
            (actionOne)="showLayerList = !showLayerList">
          </app-configurable-header>

          <div [style.display]="showLayerList ? 'block' : 'none'" class="layerContentDiv">  <!-- minimize/expand-->
            <mat-tab-group class="layer-tab">

              <mat-tab label="Inventory" id="inventoryTab">
                <div class="tab-pane" id="layersInventory" role="tabpanel" style="min-height:160px; max-height:300px">
                  <fieldset>
                    <legend class="sr-only">Checkboxes to toggle inventory layer visibility in the map</legend>
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item" *ngFor="let lyr of inventoryLayersData" [hidden]="false">
                        <div *ngIf="!currentUser.scndLang" class="sms-checkbox" (click)="toggleMapLayers($event, lyr)">
                          <mat-checkbox color="primary" [checked]="lyr.visible">
                            {{ lyr.alias ? lyr.alias : lyr.name }}
                            <img src="data:image/png;base64,{{ lyr.legendImage }}" tabindex="-1" style="margin-left: 5px" alt="{{ lyr.alias ? lyr.alias : lyr.name }} symbol"/>
                          </mat-checkbox>
                        </div>
                        <div *ngIf="currentUser.scndLang" class="sms-checkbox" (click)="toggleMapLayers($event, lyr)">
                          <mat-checkbox color="primary" [checked]="lyr.visible">
                            {{ lyr.aliasSL ? lyr.aliasSL : lyr.name }}
                            <img src="data:image/png;base64,{{ lyr.legendImage }}" tabindex="-1" style="margin-left: 5px" alt="{{ lyr.aliasSL ? lyr.aliasSL : lyr.name }} symbol"/>
                          </mat-checkbox>
                        </div>
                      </li>
                    </ul>
                  </fieldset>
                </div>
              </mat-tab>

              <mat-tab label="Reference">
                <div class="tab-pane" id="layersReference" role="tabpanel" style="min-height:160px; max-height:300px">
                  <fieldset>
                    <legend class="sr-only">Toggle reference layers in map</legend>
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item" *ngFor="let lyr of referenceLayersData">
                        <div *ngIf="!currentUser.scndLang" class="sms-checkbox" (click)="toggleMapLayers($event, lyr)">
                          <mat-checkbox color="primary" [checked]="lyr.visible">
                            {{ lyr.alias ? lyr.alias : lyr.name }}
                            <img src="data:image/png;base64,{{ lyr.legendImage }}" tabindex="-1" style="margin-left: 5px" alt="{{ lyr.alias ? lyr.alias : lyr.name }}" symbol/>
                          </mat-checkbox>
                        </div>
                        <div *ngIf="currentUser.scndLang" class="sms-checkbox" (click)="toggleMapLayers($event, lyr)">
                          <mat-checkbox color="primary" [checked]="lyr.visible">
                            {{ lyr.aliasSL ? lyr.aliasSL : lyr.name }}
                            <img src="data:image/png;base64,{{ lyr.legendImage }}" tabindex="-1" style="margin-left: 5px" alt="{{ lyr.aliasSL ? lyr.aliasSL : lyr.name }}" symbol/>
                          </mat-checkbox>
                        </div>
                      </li>
                      <li class="list-group-item" *ngFor="let lyr of visualizationLayersData" [hidden]="false">
                        <div style="display: flex; align-items: center" class="sms-checkbox" (click)="toggleVisualizationLayers(lyr)">
                          <mat-checkbox color="primary" [checked]="lyr.visible">
                            {{ lyr.originalLayerTitle }} <!-- lyr.layerName is value set in 3MAdmin. use OriginalLayerTitle to take value directly from service-->
                            <img *ngIf="lyr.legend.length > 0" src="{{ lyr.legend }}" tabindex="-1" style="margin-left: 5px" alt="{{ lyr.alias ? lyr.alias : lyr.name }} symbol"/>
                          </mat-checkbox>
                        </div>
                      </li>
                    </ul>
                  </fieldset>
                </div>
              </mat-tab>

              <!-- <mat-tab label="Legend">
                <div class="tab-pane" id="layersLegend" role="tabpanel">
                  <div id="divLegendWidget" style="padding-left:35px; padding-top:8px; min-height:150px;"></div>
                </div>
              </mat-tab> -->

            </mat-tab-group>

          </div>
        </div>

        <!-- Regions -->
        <div class="filterDiv p-3" [style.display]="showFilter ? 'block' : 'none'" data-toggle="collapse">
          <app-configurable-header
            [headingText]="'Esri-map.regiondiv.regions' | translate"
            [variant]="'none'"
            [iconOne]="showFilterList ? 'arrow-up' : 'arrow-down'"
            [tooltipOne]="showFilterList ? 'Minimize' : 'Expand'"
            (actionOne)="showFilterList = !showFilterList">
          </app-configurable-header>
          <div [style.display]="showFilterList ? 'block' : 'none'" class="filterContentDiv">   <!-- minimize/expand -->
            <fieldset>
              <legend class="sr-only">Select which region's data to include</legend>
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let reg of regionData; let i = index" [hidden]="false">
            		  <mat-radio-button color="primary" [checked]="i == 0 ? true : false" (change)="changeRegion(event, reg)">
                    {{ reg.regionName }}
                  </mat-radio-button>
                </li>
              </ul>
            </fieldset>
          </div>
        </div>

        <!-- Redline -->
        <div *ngIf="showEsriWidgets" data-html2canvas-ignore="true" id="redline">
          <sms-redline
            [map]="map"
            [drawTool]="drawTool"
            [ColorPicker]="ColorPicker"
            *ngIf="showRedlineDraw"
            [SimpleLineSymbol]="SimpleLineSymbol"
            [SimpleFillSymbol]="SimpleFillSymbol"
            [SimpleMarkerSymbol]="SimpleMarkerSymbol"
            [Color]="Color"
            [Graphic]="Graphic"
            [GraphicsLayer]="GraphicsLayer"
            (closeEvent)="close($event, 'redline')">
          </sms-redline>
        </div>

        <!-- 3M Admin -->
        <div class="query-builder-div" *ngIf="closeAdministrator">
          <sms-administrator (closeQueryBuilderEvent)="closeQueryBuilder($event)" (data)="processEmittedData($event)"> </sms-administrator>
        </div>

        <!-- Query Builder -->
        <div class="querybound">
          <div id="queryBuilderDiv" [ngClass]="{ minimized: isQueryBuilderMinimized == true }" *ngIf="closeQueryBuilderVar" data-html2canvas-ignore="true">
            <sms-query-builder
              (closeQueryBuilderEvent)="closeQueryBuilder($event)"
              (queryBuilder)="saveQBTableData($event)"
              [Query]="Query"
              [QueryTask]="QueryTask"
              (data)="processEmittedData($event)"
              [SimpleLineSymbol]="SimpleLineSymbol"
              [SimpleFillSymbol]="SimpleFillSymbol"
              [SimpleMarkerSymbol]="SimpleMarkerSymbol"
              [Color]="Color"
              [Graphic]="Graphic"
              [GraphicsLayer]="GraphicsLayer"
              [map]="map"
              [all]="all"
              [drawTool]="drawTool"
              [FeatureLayer]="FeatureLayer"
              [queryBuilderTable]="queryBuilderArray"
              [RelationshipQuery]="RelationshipQuery"
              [PictureMarkerSymbol]="PictureMarkerSymbol"
              [webMercatorUtils]="webMercatorUtils"
              [Point]="Point"
              (indexCV)="setRowIndex($event)"
              (layerIndex)="setSelLayerIndex($event)"
              (isFromQB)="closeFromQB($event)"
              (indexdata)="setRowIndex($event)"
              (layerIndex)="setSelLayerIndex($event)"
              (minimize)="toggleMinimizeQb($event)">
            </sms-query-builder>      <!-- (data)="showQueryData($event)" -->
          </div>
        </div>

        <!-- Asset Viewer aka Card view-->
        <div class="position-absolute card-view-div card" *ngIf="showEsriWidgets" id="cardViewDiv"  [ngClass]="eeService.numOfOpenPanels == 0  ?  'full-card-view'  : eeService.numOfOpenPanels == 1 ? 'half-card-view' : eeService.numOfOpenPanels == 2 ?  'small-card-view' : 'full-card-view'" >
          <div class="row" style="height:100%">
            <div class="col-12" style="height:100%">
              <sms-asset-viewer
                style="display:block; height:100%"
                *ngIf="assetViewerVisible"
                [map]="map"
                [RelationshipQuery]="RelationshipQuery"
                [FeatureLayer]="FeatureLayer"
                [Query]="Query"
                [QueryTask]="QueryTask"
                [AI]="AttributeInspector"
                [Editor]="Editor"
                (selectedRow)="(null)"
                [Point]="Point"
                [selectedSet]="selectedSet"
                [layerData]="inventoryLayersData"
                [Draw]="Draw"
                [webMercatorUtils]="webMercatorUtils"
                [Graphic]="Graphic"
                [SimpleMarkerSymbol]="SimpleMarkerSymbol"
                [SimpleLineSymbol]="SimpleLineSymbol"
                [Color]="Color"
                [Edit]="Edit"
                [geometryEngine]="geometryEngine"
                [Polygon]="Polygon"
                [geometryJsonUtils]="geometryJsonUtils"
                [selectedIndex]="index"
                [selLayerindex]="layerIndex"
                [isFromQB]="isFromQB">
              </sms-asset-viewer>
            </div>
          </div>
        </div>

        <!--Create/Edit task     2/23/26 implemented this as common sms-create-task component for entire app.    all callers responsible for setting Globals.selectedTask and .userSelectedActivity -->
        <div  aria-label="Show Task" *ngIf="showCreateTask">
          <sms-create-task
              [Graphic]="Graphic"
              [FeatureLayer]="FeatureLayer"
              [asset]="createTaskAsset"
              [taskAttributes]="editTaskAttributes"
              (showTasks)="hideCreateTaskForm()"
              [webMercatorUtils]="webMercatorUtils"
          ></sms-create-task>
        </div>

        <!-- Help Center -->
        <div class="help-div" *ngIf="closeHelpVar">
          <sms-help-center (closeHelpCenterEvent)="closeHelpCenterBuilder($event)"></sms-help-center>
        </div>

        <!-- Data Collector settings -->
        <div class="data-div" *ngIf="DataEditor">
          <div class="modal-content" style="height:unset;" cdkDrag cdkDragBoundary=".data-div">
            <div cdkDragHandle>
              <app-configurable-header [headingText]="'Datacollect.main.title' | translate" [variant]="'none'" [iconOne]="'cross'" [tooltipOne]="'Close'" (actionOne)="closeDataCollector()"> </app-configurable-header>
            </div>
            <div id="help_tab" class="modal-body p-0 help show">
              <div class="container">
                <div style="margin-bottom: 16px; margin-top: 16px" class="h7">{{ "Datacollect.main.desc" | translate }}</div>

                <div class="card mb-3">
                  <ul class="list-group list-group-flush" style="padding: 0">
                    <li class="list-group-item formbg-d2">
                      <mat-radio-button color="primary" id="New" name="optradio" [checked]="dataEditorSettings.taskType == 'New'" (change)="choose($event['source'])">
                        {{ "Datacollect.main.normaloption" | translate }}
                      </mat-radio-button>
                    </li>
                    <li class="list-group-item formbg-d2">
                      <mat-radio-button color="primary" id="Collect" name="optradio" [checked]="dataEditorSettings.taskType == 'Collect'" (change)="choose($event['source'])">
                        {{ "Datacollect.main.collectoption" | translate }}
                      </mat-radio-button>
                    </li>
                    <li class="list-group-item formbg-d2">
                      <mat-checkbox color="primary" [disabled]="currentUser.rolePermissions.roleName == 'Admin' ? false : true" [(ngModel)]="dataEditorSettings.hardDelete">
                        {{ "Datacollect.main.permanentdelecteallow" | translate }}  
                      </mat-checkbox>
                    </li>
                    <li class="list-group-item formbg-d2">
                      <mat-checkbox color="primary" [disabled]="currentUser.rolePermissions.roleName == 'Admin' ? false : true" [(ngModel)]="dataEditorSettings.IsOpenCreateEditTaskForm">
                        {{ "Datacollect.main.openCreateEditTaskForm" | translate }}
                      </mat-checkbox>
                    </li>
                  </ul>
                  <div class="card-footer bg-transparent text-right">
                    <button matButton (click)="saveDataEditor()" type="button" class="btn btn-primary">
                      {{ "Datacollect.main.saveworkordersetting" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Crew Management -->
        <div class="crew-management-div" *ngIf="crewmanagement">
          <app-sms-crewmanagement (closeCrewManagementEvent)="closeCrewManagement($event)"></app-sms-crewmanagement>
        </div>

        <!-- Crowdsourced -->
        <div class="crowd-SourcedInfo-div" *ngIf="crowdSourceVar">
          <sms-crowd-sourced-info (createTask)="createTaskforAsset($event)" (crowdsource)="crowdsource()" (closeCrowdSourceEvent)="closeCrowdSourceBuilder($event)"></sms-crowd-sourced-info>
        </div>

        <!-- Basemaps button -->
        <div class="basemapBtnsDiv p-2" data-html2canvas-ignore="true" *ngIf="basemapProLicense">
          <table>
            <tr>
              <td>
                <a href="#" class="basemapMore" title="More Basemaps" (click)="toggleBasemapGallery()" *ngIf="proLicense">
                  <mat-icon id="basemaps-more" svgIcon="arrow-left"></mat-icon>
                </a>
              </td>
              <td>
                <div id="BasemapToggleDiv" [ngClass]="{ 'basemap-btns-more': basemapProLicense, 'basemap-btns': !basemapProLicense }"></div>
              </td>
            </tr>
          </table>
        </div>

        <!-- GPS Route Logs -->
        <div class="routeLogBtnDiv p-2" *ngIf="showEsriWidgets && currentUser.soultionTiers[0][0].route_Logs" data-html2canvas-ignore="true">
          <sms-route-logs
            [map]="map"
            [GraphicsLayer]="GraphicsLayer"
            [Polyline]="Polyline"
            [Point]="Point"
            [SimpleLineSymbol]="SimpleLineSymbol"
            [Color]="Color"
            [Graphic]="Graphic"
            [webMercatorUtils]="webMercatorUtils"
            [PictureMarkerSymbol]="PictureMarkerSymbol"
            [mathUtils]="mathUtils">
          </sms-route-logs>
        </div>

        <!-- Inset Map-->
        <div class="insetMap">
          <div id="overviewMapWidget"></div>
        </div>

        <!-- time slider-->
        <div id="timeSliderDiv" class="smstimeslider">
          <div id="timeSliderHeader" class="row">
            <div class="col-2"></div>
            <div id="timeSliderHeaderLabels" class="timeSliderLabels col-6">
              <!-- <label> User : Prashant</label>
                <label> Start Time : 20-Aug-2019</label>
                <label> End Time : 20-Nov-2019</label>  -->
            </div>
            <!-- added by sowjanya JIRA ID-53 15-10-2021  -->
            <div class="col-2"></div>
            <div class="col-1">
              <button class="custbtn btn-sm" style="background-color: transparent" (click)="ExportShapefile()" aria-label="ExportShapefile">
                <span class="iconassets medium" style="transform: rotate(180deg)"></span>
              </button>
            </div>
            <div class="col-1">
              <button class="custbtn btn-sm" style="background-color: transparent" (click)="closeTimeSlider()" aria-label="icon-close">
                <span class="iconassets1 medium"></span>
              </button>
            </div>
          </div>
        </div>

        <!-- busy spinner -->
        <div class="text-center" role="status">
          <div class="spinner-border map-loader" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-border map-loader mr-4 mt-2 spinnew" role="status" *ngIf="loading">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

      </main>
    </div>
  </div>
</div>

<!-- Map Tools and Asset/Make/Maintenance Table views at bottom of Map.   why ever width=25% ? -->     <!-- TSDRSAM -1113  height 6rem -->
<div
  class="row"
  style="position: absolute; bottom: 0px; left: 0px; z-index: 1; margin-left:0px; margin-right:0px; pointer-events: none;"
  [style.width]="taskTableVisible || assetTableVisible || showSelectedTasksData || makeViewerVisible ? '100%' : '25%'"
  id="TablesDiv">     <!-- 2/19/26 added pointer-events: none to sytle so that map is not blocked by this div. needed to add pointer-events: auto to elements within the div that should be clickable. -->

  <!-- Map Tools (in TablesDiv to float above when a table is displayed) -->
  <div id="maptool" class="map-tools-div" aria-label="map tools" data-html2canvas-ignore="true" *ngIf="currentUser.soultionTiers[0][0].toolbar" style="bottom: 0px; left: 0px; z-index: 1">
    <sms-map-tools
      [map]="map"
      [extent]="Extent"
      [OverviewMap]="OverviewMap"
      [drawTool]="drawTool"
      [webMercatorUtils]="webMercatorUtils"
      [LocateButton]="LocateButton"
      [layerData]="layerData.userLayers"
      [VectorTileLayer]="VectorTileLayer"
      [region]="region"
      [Query]="Query"
      [QueryTask]="QueryTask"
      [Draw]="Draw"
      [PictureMarkerSymbol]="PictureMarkerSymbol"
    ></sms-map-tools>
  </div>

  <!-- Asset Table (aka grid) Viewer for selected set -->
  <div *ngIf="assetTableVisible" class="myMaintananceDiv">
    <sms-asset-table *ngIf="assetTableVisible" [map]="map" [FeatureTable]="FeatureTable" (selectedRow)="(null)"></sms-asset-table>
  </div>

  <!-- Maintenance Task Viewer -->
  <sms-task-table
    *ngIf="showSelectedTasksData || taskTableVisible"
    [Query]="Query"
    [QueryTask]="QueryTask"
    [map]="map"
    [Graphic]="Graphic"
    [tasksCategory]="category"
    [selectedData]="selectedSet"     
    [FeatureLayer]="FeatureLayer"
    [all]="all"
    (closeTable)="closeTaskTable($event)"
    [all]="all"
    [map]="map"
    [Point]="Point"
    (showTask)="showTaskData($event)"
    [SimpleMarkerSymbol]="SimpleMarkerSymbol"
    [SimpleFillSymbol]="SimpleFillSymbol"
    [SimpleLineSymbol]="SimpleLineSymbol"
    [Color]="Color"
    [PictureMarkerSymbol]="PictureMarkerSymbol"
    (rowDataObjVar)="displayTaskinViewer($event)"
    [RelationshipQuery]="RelationshipQuery"
    id="myMaintenanceContainer"
  ></sms-task-table>

  <!-- Make Viewer -->
  <sms-make-viewer
    *ngIf="makeViewerVisible"
    [Query]="Query"
    [QueryTask]="QueryTask"
    [map]="map"
    [Graphic]="Graphic"
    [tasksCategory]="category"
    [FeatureLayer]="FeatureLayer"
    [all]="all"
    (closeTable)="closeTaskTable($event)"
    [all]="all"
    [map]="map"
    [Point]="Point"
    (showTask)="showMakeData($event)"
    [Color]="Color"
    [PictureMarkerSymbol]="PictureMarkerSymbol"
    (rowDataObjVar)="displayTaskinViewer($event)"
    [RelationshipQuery]="RelationshipQuery"
    id="makeViewerContainer"
  ></sms-make-viewer>

</div>
 
